import { Organization as OrganizationLib } from "@secondcloset/fulfillment-utils";
import { Fulfillment, Common } from "@secondcloset/types";

import moment from "moment";

// Interfaces

type Customer = Fulfillment.Customer;
type Address = Common.BaseAddress;
type Product = Fulfillment.Product;

export const getDefaultFacilityCode = () => {
  return OrganizationLib.DEFAULT_FALLBACK_FACILITY_CODE;
};

export const getDefaultExternalOrderNumber = () => {
  return moment().format("DDMMYY_HH:mm:ss");
};

export const getDefaultCustomer = (customers: Customer[] | null) => {
  if (!customers) return null;
  return customers[0].id;
};

export const getDefaultAddress = (addresses: Address[] | null) => {
  if (!addresses) return null;
  return addresses[0].id;
};

export const getDefaultProduct = (products: Product[] | null) => {
  if (!products) return null;
  return products[0].id;
};
